// Plain Google Maps embed (maps.google.com/maps?...&output=embed) — needs no API key, unlike the
// JS Maps Embed API. Fine for a static "here's where we are" map; only reach for the API version
// if this ever needs to be interactive (custom markers, directions, etc).
export default function GoogleMapEmbed({ className = '' }) {
  return (
    <iframe
      title="East County Business Center — 270 E Douglas Ave, El Cajon, CA 92020"
      src="https://maps.google.com/maps?q=270+E+Douglas+Ave,+El+Cajon,+CA+92020&output=embed"
      className={className}
      style={{ border: 0 }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  )
}
